import { useContext } from "react";

import AllAdAccountContext from "../context/AllAdAccountProvider";

const useAllAdAccount = () => {
  return useContext(AllAdAccountContext);
}

export default useAllAdAccount;